import { useEffect, useRef, useState } from 'react'
import { Link } from 'react-router-dom'
import Contador from './contador'
import { GoIcon } from './icons/go'

export function Menu() {
    const buttonRef = useRef()
    const menuRef = useRef()
    const [open, setOpen] = useState(false)

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (
                open &&
                menuRef.current &&
                !menuRef.current.contains(event.target) &&
                !buttonRef.current.contains(event.target)
            ) {
                setOpen(false)
            }
        }

        document.addEventListener('mousedown', handleClickOutside)
        return () => {
            document.removeEventListener('mousedown', handleClickOutside)
        }
    }, [open])

    return (
        <>
            <div className="relative z-50">
                <button
                    ref={buttonRef}
                    className="bg-transparent m-0 p-0 pt-8 w-auto"
                    onClick={() => setOpen(!open)}
                    aria-label="Menu">
                    <svg
                        width="73"
                        height="48"
                        viewBox="0 0 73 48"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg">
                        <rect width="110" height="48" rx="24" fill="black" fillOpacity="0.47" />
                        <path
                            d="M33.2273 17.662H15.7727C14.7909 17.662 14 16.8451 14 15.831C14 14.8169 14.7909 14 15.7727 14H33.2273C34.2091 14 35 14.8169 35 15.831C35 16.8451 34.2091 17.662 33.2273 17.662ZM35 24C35 22.9859 34.2091 22.169 33.2273 22.169H19.7727C18.7909 22.169 18 22.9859 18 24C18 25.0141 18.7909 25.831 19.7727 25.831H33.2273C34.2091 25.831 35 25.0141 35 24ZM35 32.169C35 31.1549 34.2091 30.338 33.2273 30.338H25.7727C24.7909 30.338 24 31.1549 24 32.169C24 33.1831 24.7909 34 25.7727 34H33.2273C34.2091 34 35 33.1831 35 32.169Z"
                            fill="white"
                        />
                    </svg>
                </button>
            </div>

            {/* Overlay del menú */}
            <div
                className={`fixed inset-0 z-40 transition-opacity duration-300 ${open ? 'opacity-100 pointer-events-auto' : 'opacity-0 pointer-events-none'}`}
                onClick={() => setOpen(false)}>
                <div
                    ref={menuRef}
                    className={`
                        wrapper fixed top-0 left-0 right-0 z-50
                        bg-transparent
                        transform transition-transform duration-300 ease-out
                        ${open ? 'translate-y-0' : '-translate-y-full'}
                    `}
                    onClick={(e) => e.stopPropagation()}>
                    <div className="bg-white px-4 py-6 shadow-lg">
                        <Contenido onClick={() => setOpen(false)} />
                    </div>
                </div>
            </div>
        </>
    )
}

function Contenido({ onClick }) {
    return (
        <div className="py-4">
            <img
                src="/assets/img/logo-menu.png"
                alt="lascuatroestacionesdelsabor"
                className="max-w-24 mb-4"
            />
            <img src="/assets/img/contenido-menu.png" alt="lascuatroestacionesdelsabor" />
            <Link
                onClick={onClick}
                to="/sweetpalermo"
                className="inline-block mt-6 flex justify-between items-center">
                <span className="text-2xl text-black font-semibold">Así es Sweet Palermo</span>{' '}
                <GoIcon color="black" width="1.5rem" />
            </Link>
            <Contador className="mt-8" onClick={onClick} />
        </div>
    )
}
